import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import axios from 'axios';
import { Observable } from 'rxjs/Observable';
import { ENDPOINTS } from './app.config';
import Utils from './app.utilities';
import { CompanyService } from 'app/company.service';

const utilities = new Utils();

@Injectable()
export class AppGuard implements CanActivate {
  router: Router;

  constructor(router: Router, private companyService: CompanyService,) {
    this.router = router;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthenticated = !!utilities.getStorage('token');
    this.companyService.setCompanyId(next.params['companyId'])
    return new Promise(resolve => {
      axios.get(ENDPOINTS.GET_CURRENT_USER).then(
        responseUser => {
          const userRole = utilities.getUserRole(responseUser.data);
          const allowedRouteRoles = next.data.roles;
          if (!isAuthenticated || !allowedRouteRoles.includes(userRole)) {
            const homepage = utilities.getUserRoleHomepage(responseUser.data);
            this.router.navigate([homepage]);
            resolve(false);
          }
          resolve(true);
        },
        errorGettingUser => {
          this.router.navigate(['']);
          resolve(false);
        },
      );
    });
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.guard.ts